"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const Path_1 = require("../Util/Path");
const configs_1 = require("../configs/configs");
const TooManyValuationError_1 = require("../Error/TooManyValuationError");
class RestrictedValuationApi {
    constructor(config, httpClient, errorTransformer) {
        this.config = config;
        this.httpClient = httpClient;
        this.errorTransformer = errorTransformer;
    }
    static create(config, container) {
        return new this(config, container.get('http_client'), container.get('transformer.axios_to_error'));
    }
    restrictedValuationsCheck() {
        const url = Path_1.default.route(configs_1.configs.endpoints.restrictedValuation);
        return this.httpClient.get(url)
            .catch(err => {
            if (err.response.status === 401) {
                const errorValuation = new TooManyValuationError_1.default(err.message);
                throw errorValuation;
            }
            throw this.errorTransformer.to(err);
        });
    }
}
exports.default = RestrictedValuationApi;
Mixin_1.default(RestrictedValuationApi, IContainerInjection_1.default);
